(function () {
  'use strict';
  var ui = window.ByteRescueUI, captcha = window.ByteRescueCaptcha;
  if (!ui || !captcha || window.ByteRescueBusinessLoaded) return;
  window.ByteRescueBusinessLoaded = true;
  var lang = /^ja/i.test(document.documentElement.lang) ? 'ja' : /^zh/i.test(document.documentElement.lang) ? 'zh' : 'en';
  var copy = {
    en: { sending: 'Sending your inquiry…', failed: 'We could not confirm receipt. Your details are saved here; please try again.', verify: 'Verification could not finish. Please try again.', rate: 'Please wait a few minutes before trying again.', unavailable: 'Online inquiries are temporarily unavailable. Please contact us by email.', reference: 'Reference: ', invalid: 'Please check the required fields.', success: 'Thank you. We received your business inquiry and will review it.' },
    ja: { sending: 'お問い合わせを送信しています…', failed: 'お問い合わせを受け付けたか確認できませんでした。入力内容はそのまま残っています。もう一度お試しください。', verify: '認証を完了できませんでした。もう一度お試しください。', rate: '数分お待ちいただいてから、もう一度お試しください。', unavailable: '現在フォームをご利用いただけません。メールでお問い合わせください。', reference: '受付番号：', invalid: '必須項目をご確認ください。', success: 'お問い合わせを受け付けました。内容を確認します。' },
    zh: { sending: '正在提交咨询…', failed: '暂时无法确认咨询是否提交成功。填写内容已保留，请重试。', verify: '验证未能完成，请重试。', rate: '请稍等几分钟后再试。', unavailable: '在线咨询暂不可用，请通过邮箱联系我们。', reference: '咨询编号：', invalid: '请检查必填项。', success: '已收到你的企业咨询，我们会查看具体情况。' }
  }[lang];
  function initialize(scope) {
    captcha.initialize(scope);
    ui.scopedNodes(scope, '[data-business-request-form]').forEach(function (form) {
      if (form.dataset.businessBound) return;
      form.dataset.businessBound = 'true';
      form.addEventListener('submit', function (event) { event.preventDefault(); });
      var submit = form.querySelector('[type="submit"]'), status = form.querySelector('[data-business-status]');
      var endpoint = form.dataset.workbenchEndpoint;
      var busy = false, completed = false, fingerprint = '', submissionId = '', blockedUntil = 0;
      function show(text, error) { status.textContent = text; status.classList.toggle('br-form-error', Boolean(error)); }
      try {
        var url = new URL(endpoint);
        if (url.pathname !== '/api/public/business-inquiries' || (url.protocol !== 'https:' && url.hostname !== '127.0.0.1')) throw new Error('Invalid endpoint');
        if (!form.dataset.recaptchaSiteKey || !window.crypto || !window.crypto.randomUUID) throw new Error('Unavailable');
        submit.disabled = false;
      } catch (_) { show(copy.unavailable, true); return; }
      form.addEventListener('submit', async function (event) {
        event.preventDefault();
        if (busy || completed) return;
        if (!form.reportValidity()) return;
        if (Date.now() < blockedUntil) return show(copy.rate, true);
        var value = function (name) { return ui.formValue(form, 'contact[' + name + ']'); };
        var payload = { name: value('name'), company: value('company'), email: value('email'), phone: value('phone'), teamSize: value('team_size'), zip: value('zip'), message: value('body'), locale: document.documentElement.lang, consent: form.querySelector('[name="contact[consent]"]').checked };
        var next = JSON.stringify(payload);
        if (next !== fingerprint) { fingerprint = next; submissionId = window.crypto.randomUUID(); }
        payload.submissionId = submissionId;
        payload.companyWebsite = form.querySelector('[name="company_website"]').value;
        payload.formStartedAt = Number(form.dataset.formStartedAt);
        busy = true; submit.disabled = true; form.setAttribute('aria-busy', 'true'); show(copy.sending);
        ui.publishAnalyticsEvent('request_started', { lead_type: 'business_inquiry', team_size: payload.teamSize });
        var phase = 'verification', controller, timer;
        try {
          payload.recaptchaToken = await captcha.token(form);
          phase = 'submission'; controller = new AbortController();
          timer = setTimeout(function () { controller.abort(); }, 15000);
          var response = await fetch(endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json' }, credentials: 'omit', body: JSON.stringify(payload), signal: controller.signal });
          var result = await response.json();
          if (!response.ok) {
            if (response.status === 429) {
              var seconds = Number(response.headers.get('Retry-After') || result.retryAfter || 180);
              blockedUntil = Date.now() + Math.max(1, Math.min(Number.isFinite(seconds) ? seconds : 180, 1800)) * 1000;
              throw new Error(copy.rate);
            }
            if (response.status === 403) throw new Error(copy.verify);
            if (result.code === 'SUBMISSION_CONFLICT') fingerprint = '';
            throw new Error(response.status === 400 ? copy.invalid : copy.failed);
          }
          if (!result.ok || !result.workOrderId) throw new Error(copy.failed);
          completed = true;
          form.querySelectorAll('input, select, textarea').forEach(function (field) { field.disabled = true; });
          show((form.dataset.successMessage || copy.success) + ' ' + copy.reference + result.workOrderId);
          ui.publishAnalyticsEvent('generate_lead', { lead_type: 'business_inquiry', team_size: payload.teamSize });
        } catch (error) {
          show(phase === 'verification' ? copy.verify : [copy.rate, copy.verify, copy.invalid].includes(error.message) ? error.message : copy.failed, true);
        } finally {
          clearTimeout(timer); busy = false; submit.disabled = completed; form.removeAttribute('aria-busy');
        }
      });
    });
  }
  initialize(document);
  document.addEventListener('shopify:section:load', function (event) { initialize(event.target); });
})();
